import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminGet } from './adminApi';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const mono = { fontFamily: "'IBM Plex Mono', monospace" };

export default function AdminCustomersPage() {
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    adminGet('/customers').then(setCustomers).catch(e => toast.error(e.message));
  }, []);

  return (
    <div className="p-8 max-w-6xl" data-testid="admin-tenants-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-4xl font-bold" style={{ color: '#1B1D1C' }}>Tenants</h1>
        <Button data-testid="new-customer-btn" onClick={() => navigate('/admin/tenants/new')}
          className="text-white hover:opacity-90" style={{ background: '#0B6B55' }}>Add tenant</Button>
      </div>
      <div className="rounded-lg border bg-white overflow-x-auto" style={{ borderColor: '#E5E3DC' }}>
        <table className="w-full text-sm">
          <thead><tr className="text-left border-b" style={{ color: '#6b7069', borderColor: '#EDEBE4' }}>
            <th className="py-3 px-4 font-medium">Tenant</th><th className="font-medium">Type</th>
            <th className="font-medium">Pod</th><th className="font-medium">Compliance</th>
            <th className="font-medium">Seats</th><th className="font-medium pr-4">Status</th></tr></thead>
          <tbody>
            {customers.map(c => (
              <tr key={c.id} data-testid={`customer-row-${c.code}`} className="border-b hover:bg-[#FAF9F6] cursor-pointer" style={{ borderColor: '#F3F1EA' }}
                onClick={() => navigate(`/admin/tenants/${c.id}`)}>
                <td className="py-3 px-4 font-medium">{c.legal_name}<span className="ml-2 text-xs" style={{ ...mono, color: '#9a9e96' }}>{c.code}</span></td>
                <td data-testid={`tenant-type-${c.code}`}>{c.vertical_code ? c.vertical_code.toLowerCase() : (['BANK', 'BANK_P2'].includes(c.profile_type) ? 'bfsi (legacy)' : '—')}{c.customer_type_code ? <span className="text-xs ml-1" style={{ color: '#9a9e96' }}>· {c.customer_type_code}</span> : null}</td>
                <td style={mono} data-testid={`tenant-pod-${c.code}`}>{c.pod || 'shared'}</td>
                <td>{c.compliance_tier || '—'}</td>
                <td style={mono}>{c.seat_limit}</td>
                <td className="pr-4">
                  <span className="px-2 py-0.5 rounded text-xs" style={c.status === 'SUSPENDED'
                    ? { background: '#FBEBEB', color: '#8C2B2B' } : { background: '#E7F2EE', color: '#0B6B55' }}>
                    {c.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs mt-3" style={{ color: '#9a9e96' }}>Click a tenant to open its profile — features, security, devices and audit trail.</p>
    </div>
  );
}
